import { render, staticRenderFns } from "./EditorConductoresCopiloto.vue?vue&type=template&id=e8d55864&scoped=true&"
import script from "./EditorConductoresCopiloto.vue?vue&type=script&lang=ts&"
export * from "./EditorConductoresCopiloto.vue?vue&type=script&lang=ts&"
import style0 from "./EditorConductoresCopiloto.vue?vue&type=style&index=0&id=e8d55864&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d55864",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('e8d55864', component.options)
    } else {
      api.reload('e8d55864', component.options)
    }
    module.hot.accept("./EditorConductoresCopiloto.vue?vue&type=template&id=e8d55864&scoped=true&", function () {
      api.rerender('e8d55864', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CopilotoVirtual/Conductores/EditorConductoresCopiloto.vue"
export default component.exports